import VMonthPicker from '../components_v/v-month-picker'
import { defaultFun } from '../utils'
import { MONTH_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: MONTH_FIELD,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             change = defaultFun,
             'click:clear': click_clear = defaultFun,
             ...params 
            } = this.field
            params.locale = params.locale || "zh-cn"
            if (params.attach === undefined) {
                params.attach = true
            }
        return h(VMonthPicker, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                field: params,
                value: this.my_value[key]
            },
            on: {
                change:(data) => {
                    this.my_value[key] = data
                    change(data)
                },
                clear:(data) => {
                    this.my_value[key] = null
                    click_clear(data)
                },
            }
        })
    }
}